export const SANITISE_SETTINGS = {
  allowedAttributes: {
    //sanitize-html default
    a: ['href', 'name', 'target'],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
    //DRIVE additions
    h1: ['id'],
    h2: ['id'],
    h3: ['id'],
    h4: ['id'],
    h5: ['id'],
    h6: ['id'],
    div: ['id'],
  },
};
